import React from 'react';
import discord from './../images/images-master/icons-svg/discord.svg'
import instagram from './../images/images-master/icons-svg/instagram.svg'
import telegram from './../images/images-master/icons-svg/telegram.svg'
import LinkImageFooter from './Refactorizaction/LinkImageFooter';

const FooterLinksImages = ({ LinkDiscord, LinkInstagram, LinkTelegram }) => (
    <section className="social-media-footer">
        < LinkImageFooter Link={LinkDiscord}    ImageFooter={discord}   />
        < LinkImageFooter Link={LinkInstagram}  ImageFooter={instagram} />
        < LinkImageFooter Link={LinkTelegram}   ImageFooter={telegram}  />
    </section>
)

export default FooterLinksImages;
